import React from 'react';
import ArtisanPreferenceModal from '../../Components/Profile/ArtisanPreferenceModal';
import { regionOptions } from '../../Config/franceRegions';

const RegionModal = ({ showModal, handleClick }) => (
  <ArtisanPreferenceModal
    opened={showModal === 'open'}
    close={handleClick}
    field="artisan_region"
    title="Modifier votre région principale"
    description="Cette région présente votre implantation. Votre rayon et vos préférences de mobilité déterminent les projets visibles."
    label="Région principale"
    options={regionOptions}
  />
);

export default RegionModal;
